import { Box, Button, CircularProgress, FormControl, Grid, Typography } from '@mui/material';
import { Form } from 'formik';
import React from 'react';
// import { useState } from 'react';
import { gridSpacing } from 'store/constant';
import SettingsView from 'ui-component/cards/Skeleton/SettingsView';
import AnimateButton from 'ui-component/extended/AnimateButton';
// import { useGetAllMachinePrice } from 'hooks/useSettingsHooks';
import DocumentUploadMachine from 'views/pages/machines/files/uploader';
import { useTheme } from '@mui/system';
import { useGetSuperAdminAds } from 'hooks/useSettingsHooks';
// import { useGetAllMachinePrice } from 'hooks/useSettingsHooks';
const MachineAdvertisementsForm = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
  isLoadingMachinePrice,
  handleSubmit,
  isSubmitting,
  isUploadingMachineAdvertisements

  // isLoadingMachineModel, setFieldValue
}) => {
  // const [loading, setLoading] = useState(false);
  const { data: getSuperAdminAds, isPending: isSuperAdminAds } = useGetSuperAdminAds({});
  React.useEffect(() => {
    if (getSuperAdminAds) {
      setFieldValue('documents', getSuperAdminAds || []);
    }
  }, [setFieldValue, getSuperAdminAds]);
  // console.log('getSuperAdminAds', getSuperAdminAds);

  const theme = useTheme();
  return (
    <>
      {isSuperAdminAds ? (
        <>
          <SettingsView />
        </>
      ) : (
        <>
          <Form>
            <Grid item xs={12}>
              <Typography component="h4" variant="h2" sx={{ mb: 2 }}>
                Machine Advertisements
              </Typography>
              <Grid container spacing={gridSpacing}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography component="h5" variant="h4" sx={{ mb: 2 }}>
                    Added advertisements will show as default in all machines.
                  </Typography>
                  <Grid
                    container
                    className="machine-base-price"
                    //   className="settings-row-page"
                  >
                    <Grid container spacing={gridSpacing}>
                      <Grid item xs={12} sm={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.documents && errors.documents)}
                          sx={{ ...theme.typography.customInput }}
                        >
                          <DocumentUploadMachine
                            {...{
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                              setFieldValue
                              //   imageDetails
                            }}
                            from={'superAdminAdvertisement'}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 5,
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'center'
                }}
              >
                <Box sx={{ display: 'inline-block' }}>
                  <AnimateButton>
                    <Button
                      disableElevation
                      disabled={isLoadingMachinePrice}
                      size="large"
                      type="submit"
                      variant="contained"
                      color="secondary"
                      style={{
                        color: 'white',
                        minWidth: '200px',
                        margin: '0px auto'
                      }}
                    >
                      {isUploadingMachineAdvertisements ? (
                        <>
                          <CircularProgress
                            sx={{
                              color: 'white',
                              height: 20,
                              width: 20
                            }}
                          />
                        </>
                      ) : (
                        `Save`
                      )}
                    </Button>
                  </AnimateButton>
                </Box>
              </Box>
            </Grid>
          </Form>
        </>
      )}
    </>
  );
};

export default MachineAdvertisementsForm;
